import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import Layout from "../../components/layout/Layout";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  Typography,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { Grid, Box, Paper, Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import Admin from "../../components/auth/Admin";
import Order from "../../actions/order";
import Customer from "../../actions/customer";
import Controls from "../../components/controls/Controls";
import { FiEye } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from "@mui/icons-material/Clear";
import {
  calculateTotalSumOrderProducts,
  formatNumber,
  getTimestamp,
  paymentLists,
} from "../../utils/utils";
import PrintIcon from "@mui/icons-material/Print";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
const noPrintStyle = {
  display: "none",
};
const useStyles = makeStyles((theme) => ({
  table: {
    marginTop: theme.spacing(3),
    width: "100%",
    "& thead th": {
      fontWeight: "600",
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.primary.main,
    },
    "& tbody td": {
      fontWeight: "300",
      padding: "8px",
    },
    "& tbody tr:hover": {
      backgroundColor: "#fffbf2",
      cursor: "pointer",
    },
  },
}));

const headCells = [
  { id: "id", label: "Id" },
  { id: "assignTo", label: "Assigned To" },
  { id: "quantity", label: "Item Count" },
  { id: "totalPrice", label: "Total Price" },
  { id: "paid", label: "Paid" },
  { id: "unpaid", label: "Balance" },
  { id: "createdAt", label: "Date" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const TblHead = ({ headCells, isPrinting }) => (
  <TableHead>
    <TableRow>
      {headCells.map((cell) => {
        if (cell.id === "actions" && isPrinting) return null;
        return <TableCell key={cell.id}>{cell.label}</TableCell>;
      })}
    </TableRow>
  </TableHead>
);

const PaymentReport = () => {
  const classes = useStyles();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllOrders } = Order();
  const { viewAllCustomers } = Customer();
  const [isPrinting, setIsPrinting] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState("");
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    getAllOrders();
    getAllCustomers();
  }, []);

  const getAllCustomers = () => {
    viewAllCustomers().then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.customers) {
        setCustomers(data.customers);
      }
    });
  };

  const getAllOrders = () => {
    viewAllOrders().then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.orders) {
        const modifiedOrders = data.orders
          .filter((order) => order.status !== "Pending")
          .map((order) => ({
            ...order,
            customer: order?.customer?.fullName,
          }));
        setOrders(modifiedOrders);
        setLoading(false);
      }
    });
  };

  const groupOrdersByCustomer = (ordersArray) => {
    const groupedOrders = {};
    ordersArray.forEach((order) => {
      const customerId = order.customer;
      if (!groupedOrders[customerId]) {
        groupedOrders[customerId] = [];
      }
      groupedOrders[customerId].push(order);
    });
    return groupedOrders;
  };

  const calculateTotalPrice = (orders) => {
    return orders
      .reduce((total, order) => {
        return total + parseFloat(order.totalPrice || 0);
      }, 0)
      .toFixed(2);
  };

  const calculateTotalPaid = (orders) => {
    return orders
      .reduce((total, order) => {
        return total + parseFloat(order.paid || 0);
      }, 0)
      .toFixed(2);
  };
  const handlePrint = () => {
    setIsPrinting(true);

    setTimeout(() => {
      const input = document.getElementById("pdfContent");

      if (!input) return;
      const originalStyle = input.getAttribute("style");
      input.setAttribute("style", "font-size: 2px;");

      const opt = {
        filename: `Payment_Report_${getTimestamp()}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, scrollY: -window.scrollY },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };

      html2pdf()
        .set(opt)
        .from(input)
        .save()
        .finally(() => {
          // Restore original style after printing
          if (originalStyle !== null) {
            input.setAttribute("style", originalStyle);
          } else {
            input.removeAttribute("style");
          }
          setIsPrinting(false);
        });
    }, 0);
  };

  const resetFilter = () => {
    setSelectedCustomer(null);
    setStartDate(null);
    setEndDate(null);
    setSelectedPayment(null);
  };
  const handlePaymentChange = (event) => {
    const value = event.target.value;
    setSelectedPayment(value);
  };
  const filteredOrders = orders.filter((order) => {
    const orderCustomerFullName = order.customer;
    const orderDate = dayjs(order.createdAt);
    if (
      selectedCustomer &&
      orderCustomerFullName !== selectedCustomer.fullName
    ) {
      return false;
    }

    if (startDate) {
      const start = startDate.startOf("day");
      if (orderDate.isBefore(start)) {
        return false;
      }
    }

    if (endDate) {
      const end = endDate.endOf("day");
      if (orderDate.isAfter(end)) {
        return false;
      }
    }
    if (selectedPayment) {
      const paid = Number(order.paid);
      const totalPrice = parseFloat(calculateTotalPrice(order.orderProducts));

      if (selectedPayment === "Paid") {
        return paid > 0 && totalPrice - paid === 0;
      } else if (selectedPayment === "Balance") {
        return totalPrice - paid > 0 || totalPrice - paid < 0;
      }
    }

    return true;
  });

  const groupedOrders = groupOrdersByCustomer(filteredOrders);

  const calculateGrandTotalPrice = (ordersArray) => {
    return ordersArray
      .reduce((total, order) => {
        return (
          total + parseFloat(calculateTotalPrice(order.orderProducts) || 0)
        );
      }, 0)
      .toFixed(2);
  };

  const calculateGrandTotalPaid = (ordersArray) => {
    return ordersArray
      .reduce((total, order) => {
        return total + parseFloat(order.paid || 0);
      }, 0)
      .toFixed(2);
  };
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Payment Report
          </Typography>
          <Box display="flex" justifyContent="start" gap={2} m={1}>
            <Autocomplete
              options={customers}
              sx={{ width: "20%", marginTop: "10px" }}
              value={selectedCustomer}
              disableClearable
              getOptionLabel={(option) => option.fullName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Customer"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment position="end">
                        {selectedCustomer && (
                          <ClearIcon
                            onClick={() => setSelectedCustomer(null)}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                        {params.InputProps.endAdornment} {}
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              onChange={(event, value) => {
                setSelectedCustomer(value);
              }}
            />

            <TextField
              id="outlined-select-status"
              select
              value={selectedPayment}
              label="Filter By Payment"
              sx={{ width: "17%", marginTop: "10px" }}
              onChange={handlePaymentChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {selectedPayment && (
                      <ClearIcon
                        onClick={() => setSelectedPayment(null)}
                        style={{ cursor: "pointer", marginRight: "7px" }}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            >
              {paymentLists().map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <Box sx={{ width: "20%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={setStartDate}
                    sx={{ width: "100%" }}
                    format="MM/DD/YYYY"
                    slotProps={{
                      field: {
                        clearable: true,
                        onClear: () => setStartDate(null),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box sx={{ width: "20%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={setEndDate}
                    format="MM/DD/YYYY"
                    sx={{ width: "100%" }}
                    slotProps={{
                      field: {
                        clearable: true,
                        onClear: () => setEndDate(null),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box>
              <Controls.Button
                text="Print"
                variant="outlined"
                startIcon={<PrintIcon />}
                className="newButton"
                onClick={handlePrint}
              />
            </Box>
            <Box>
              <Controls.Button
                text="Reset Filter"
                variant="outlined"
                onClick={resetFilter}
              />
            </Box>
          </Box>
          <div id="pdfContent">
            <Grid container>
              <Grid item xs={12} className="card__body">
                {loading ? (
                  <Loading />
                ) : Object.keys(groupedOrders).length === 0 ? (
                  <Norecords />
                ) : (
                  Object.keys(groupedOrders).map((customerId) => (
                    <div key={customerId}>
                      <Typography variant="h6">
                        <span style={{ textTransform: "capitalize" }}>
                          {groupedOrders[customerId][0].customer}
                        </span>
                      </Typography>
                      <Paper
                        style={{ overflowX: "auto", marginBottom: "20px" }}
                      >
                        <TableContainer>
                          <Table className={classes.table}>
                            <TblHead
                              headCells={headCells}
                              isPrinting={isPrinting}
                            />
                            <TableBody>
                              {groupedOrders[customerId].map((item) => (
                                <TableRow key={item.id}>
                                  <TableCell>
                                    {item.orderId
                                      ? item.orderId
                                      : `${item.id.slice(0, 7)}--`}
                                  </TableCell>
                                  <TableCell>{item.staff?.fullName}</TableCell>
                                  <TableCell>
                                    {item?.orderProducts?.length}
                                  </TableCell>
                                  <TableCell>
                                    {formatNumber(
                                      calculateTotalPrice(item.orderProducts) ||
                                        0
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {formatNumber(item.paid)}
                                  </TableCell>
                                  <TableCell>
                                    {formatNumber(
                                      calculateTotalPrice(item.orderProducts) -
                                        item.paid
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {new Date(item.createdAt).toLocaleString()}
                                  </TableCell>
                                  <TableCell>{item.status}</TableCell>
                                  <TableCell
                                    style={isPrinting ? noPrintStyle : {}}
                                  >
                                    <Controls.ActionButton
                                      color="primary"
                                      title="View Detail"
                                      onClick={() => {
                                        history.push(`/print/${item.id}`);
                                      }}
                                    >
                                      <FiEye fontSize="medium" />
                                    </Controls.ActionButton>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-end",
                            flexDirection: "column",
                            p: 1,
                            gap: 1,
                            m: 1,
                            bgcolor: "background.paper",
                            borderRadius: 1,
                          }}
                        >
                          <Typography variant="h6">
                            Total Price:{" "}
                            {formatNumber(
                              calculateTotalSumOrderProducts(
                                groupedOrders[customerId]
                              )
                            )}
                          </Typography>
                          <Typography variant="h6">
                            Total Paid:{" "}
                            {formatNumber(
                              calculateTotalPaid(groupedOrders[customerId])
                            )}
                          </Typography>
                          <Typography variant="h6">
                            Total Balance:{" "}
                            {formatNumber(
                              calculateTotalSumOrderProducts(
                                groupedOrders[customerId]
                              ) - calculateTotalPaid(groupedOrders[customerId])
                            )}
                          </Typography>
                        </Box>
                      </Paper>
                    </div>
                  ))
                )}

                {Object.keys(groupedOrders).length > 0 && (
                  <Paper
                    style={{
                      overflowX: "auto",
                      marginTop: "30px",
                      padding: "20px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        flexDirection: "column",
                        gap: 2,
                        bgcolor: "background.paper",
                        borderRadius: 1,
                      }}
                    >
                      <Typography variant="h5" style={{ marginBottom: "5px" }}>
                        Total Summary (All Customers)
                      </Typography>
                      <Typography variant="h6">
                        Total Price:{" "}
                        {formatNumber(calculateGrandTotalPrice(filteredOrders))}
                      </Typography>
                      <Typography variant="h6">
                        Total Paid:{" "}
                        {formatNumber(calculateGrandTotalPaid(filteredOrders))}
                      </Typography>
                      <Typography variant="h6">
                        Total Balance:{" "}
                        {formatNumber(
                          calculateGrandTotalPrice(filteredOrders) -
                            calculateGrandTotalPaid(filteredOrders)
                        )}
                      </Typography>
                    </Box>
                  </Paper>
                )}
              </Grid>
            </Grid>
          </div>
          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};

export default PaymentReport;
